interface IconProps {
  color: string;
}

export const HearthIcon = ({ color }: IconProps) => (
  <svg viewBox="325.05 446.64 159.88 136.64">
    <path
      fill={color}
      d="m473.188 515.078-11.5 11.5-56.7 56.703-56.695-56.699-11.504-11.504c-15.652-15.66-15.652-41.043 0-56.695 7.824-7.836 18.094-11.746 28.348-11.746 10.265 0 20.523 3.91 28.355 11.746l11.496 11.496 11.5-11.496c7.832-7.836 18.09-11.746 28.348-11.746 10.262 0 20.52 3.91 28.351 11.746 15.657 15.652 15.657 41.035 0 56.695m0 0"
    ></path>
  </svg>
);
